import { combineReducers } from 'redux';

import dashboardReducer from './reducers/dashboard.reducer';

export default combineReducers({
  dashboard: dashboardReducer,
});
